/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Error } from '../models/Error'
import type { ResponseAdmin } from '../models/ResponseAdmin'
import type { ResponseSalesDepartment } from '../models/ResponseSalesDepartment'

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class SalesService {
  /**
   * Pobiera listę działów dostępnych dla operatora
   *
   * @returns ResponseSalesDepartment tablica działów
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getSalesDepartments(): CancelablePromise<
    Array<ResponseSalesDepartment> | Error
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales/departments',
    })
  }

  /**
   * Pobiera listę pracowników wybranego działu (wraz z działami podrzędnymi)
   *
   * @returns ResponseAdmin tablica pracowników
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getSalesEmployees({
    departmentId,
  }: {
    /**
     * identyfikator działu
     */
    departmentId?: string
  }): CancelablePromise<Array<ResponseAdmin> | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/sales/employees/',
      query: {
        departmentId: departmentId,
      },
    })
  }
}
